import React, { ReactNode } from 'react';

import { Component, LucidTheme } from '../../types/types';
import Box from '../box/box';
import Card from '../card/card';

export interface FeatureGridItemProps {
  /** The children to be rendered. */
  children?: ReactNode;
  /**  The grid section variant type for the Feature Grid component */
  variant?: Component.Type['FeatureGrid']['Container'];
}

const FeatureGridItem: React.FC<FeatureGridItemProps> = ({ children, variant, ...rest }) => {
  return variant === 'cards' ? (
    <Card
      {...rest}
      className="feature-grid__item"
      css={(theme: LucidTheme) => ({
        padding: theme.space.s32,
        textAlign: 'center',
        display: 'grid',
        gridTemplateRows: 'auto 1fr',
        justifyItems: 'center',
        div: {
          display: 'flex',
          flexDirection: 'column',
        },
        a: {
          display: 'block',
          textAlign: 'right',
          marginTop: 'auto',
        },
      })}
      variant="raised"
    >
      {children}
    </Card>
  ) : (
    <Box {...rest} className="feature-grid__item" css={{ alignItems: 'center', justifyContent: 'center' }}>
      {children}
    </Box>
  );
};

export default FeatureGridItem;
